import get from 'lodash.get';

const getSupportEmail = (rootState) =>
  get(rootState, 'user.partnerData.properties.supportEmail', null);

export default getSupportEmail;
